import { FC } from 'react';
import { IconPath, IconSVG, IconSVGComponentProps } from '../IconComponent';

export const ChartGantt: FC<IconSVGComponentProps> = ({
    pathProps,
    ...props
}) => {
    return (
        <IconSVG {...props}>
            <IconPath
                d="M1 5H9M9 5V1M9 5V9M9 9H3M9 9V13M9 13V17M9 13H5M19 13H13M16 9H13M13 5H14"
                {...pathProps}
            />
        </IconSVG>
    );
};
